import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { activeGroups, hasConsent, hasTargetingConsent, initPrivacySignals } from '../consent/otBridge';
import { CATEGORIES } from '../consent/otCategories';

const ConsentContext = createContext({
  groups: [],
  performance: false,
  targeting: false,
  personalizedAds: false,
  openPreferences: () => {},
});

export function ConsentProvider({ children }) {
  const [groups, setGroups] = useState(activeGroups());
  const refresh = useCallback(() => setGroups(activeGroups()), []);

  useEffect(() => {
    initPrivacySignals();
    // Both events cover every consent change: OneTrustGroupsUpdated (SDK) and
    // ot-consent-ready (from OptanonWrapper, which the SDK calls on load and on
    // every change). We intentionally do NOT use OneTrust.OnConsentChanged — it
    // has no deregister API, so it would leak the callback on remount.
    window.addEventListener('OneTrustGroupsUpdated', refresh);
    window.addEventListener('ot-consent-ready', refresh);
    return () => {
      window.removeEventListener('OneTrustGroupsUpdated', refresh);
      window.removeEventListener('ot-consent-ready', refresh);
    };
  }, [refresh]);

  const value = {
    groups,
    performance: hasConsent(CATEGORIES.PERFORMANCE),
    targeting: hasConsent(CATEGORIES.TARGETING),
    personalizedAds: hasTargetingConsent(),
    openPreferences: () =>
      window.OneTrust && window.OneTrust.ToggleInfoDisplay && window.OneTrust.ToggleInfoDisplay(),
  };
  return <ConsentContext.Provider value={value}>{children}</ConsentContext.Provider>;
}

export const useConsent = () => useContext(ConsentContext);
